/**
 * Persist E.164 from react-phone-input-2's raw `value` (digits + country
 * calling code, no "+") instead of `formattedValue` (spaces / dashes).
 * ENR-2620 — pairs with `disableCountryGuess` so the studio default country
 * drives the dial code unless the user explicitly picks another.
 */
export function phoneInputValueToE164(value: string): string {
  if (value == null) return '';
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '';
  return `+${digits}`;
}
